import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import SponsorsSection from "../components/SponsorsSection";
import AboutSection from "../components/AboutSection";
import OfficeBearersSection from "../components/OfficeBearersSection";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <SponsorsSection />
        <AboutSection />
        <OfficeBearersSection />
      </main>
      <Footer />
    </>
  );
}
